export default __webpack_public_path__ + "static/media/4.32d24e39.png";